import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const imageUrl = (id) => `${API}/gallery/image/${id}`;

export const getToken = () => localStorage.getItem("av_token");
export const setToken = (t) => localStorage.setItem("av_token", t);
export const clearToken = () => localStorage.removeItem("av_token");

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
